import { memo } from 'react';
import { type MentionsInputStyle } from 'react-mentions';

import { Avatar } from '@air/primitive-avatar';
import { formatFullName, formatInitials } from '@air/utilities';

import { type MentionsData } from '~/components/DiscussionsV2/DiscussionForm';
import { DISCUSSION_COMMENT_AVATAR, MENTION_SUGGESTION } from '~/constants/testIDs';
import { preventDefaultMouseEvent } from '~/utils/ClickUtils';
import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';

export const inputStyles: MentionsInputStyle = {
  control: {
    fontSize: '0.875rem',
  },
  suggestions: {
    marginTop: 0,
    borderRadius: '4px',
    width: '280px',
    backgroundColor: 'transparent',
    list: {
      border: '1px solid var(--colors-gray-5)',
      boxSizing: 'border-box',
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.05), 0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 9px 24px 0 rgba(0, 0, 0, 0.2)',
      borderRadius: '4px',
      background: 'var(--colors-gray-1)',
      width: '100%',
      maxHeight: '296px',
      overflowY: 'auto',
    },
  },
};

export const MENTION_SUGGESTION_ID = 'mention-suggestion';

export const Suggestion = memo(({ avatar, firstName, lastName, id: userId }: MentionsData) => (
  // biome-ignore lint/a11y/noStaticElementInteractions: react-mentions wraps this in a listbox option; mousedown only prevents textarea blur
  <div
    className="flex cursor-pointer items-center px-4 py-3 ads:hover:bg-hover-subtle hover:bg-gray-4"
    data-testid={MENTION_SUGGESTION}
    id={MENTION_SUGGESTION_ID}
    onMouseDown={preventDefaultMouseEvent}
  >
    <Avatar
      alt={`${firstName} ${lastName} avatar`}
      data-testid={DISCUSSION_COMMENT_AVATAR}
      size={24}
      src={getAvatarImageSrc(avatar, 24)}
      text={formatInitials(firstName, lastName)}
      colorSeed={userId}
    />

    <div
      data-testid="MENTION_SUGGESTION_USERNAME"
      className="ml-3 w-[calc(100%-36px)] truncate ads:text-primary text-14 text-gray-12"
    >
      {formatFullName(firstName, lastName)}
    </div>
  </div>
));

Suggestion.displayName = 'Suggestion';
